import { render, staticRenderFns } from "./LeftCenter.vue?vue&type=template&id=7596960a&scoped=true"
import script from "./LeftCenter.vue?vue&type=script&lang=js"
export * from "./LeftCenter.vue?vue&type=script&lang=js"
import style0 from "./LeftCenter.vue?vue&type=style&index=0&id=7596960a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7596960a",
  null
  
)

export default component.exports